module.exports = __webpack_public_path__ + "img/ennetix-report-page4.e2b91545.png";